import { gql } from "lib/apolloClient";

export const academicYearFragment = {
  academicYearBasicDetails: gql`
    fragment academicYearBasicDetailsItem on AcademicYear {
      id
      startDate
      endDate
      isCurrentAcademicYear
      isUpcomingAcademicYear
      isPreviousAcademicYear
      transitionReviewStatus
      dependentEntities {
        id
      }
      terms {
        id
        label
        startDate
        endDate
        lockingStatus
        curriculumProgram {
          id
        }
        dependentEntities {
          id
        }
        type
        dependentEntitiesV2 {
          totalCount
        }
      }
    }
  `,
  academicYearBasicDetailsWithFilters: gql`
    fragment academicYearBasicDetailsItem on AcademicYear {
      id
      startDate
      endDate
      isCurrentAcademicYear
      isUpcomingAcademicYear
      isPreviousAcademicYear
      transitionReviewStatus
      dependentEntities {
        id
      }
      terms(filters: $termsFilters) {
        id
        label
        type
        startDate
        endDate
        lockingStatus
        curriculumProgram {
          id
        }
        dependentEntitiesV2 {
          totalCount
        }
      }
    }
  `,
};

export const academicTermFragment = {
  termBasicDetails: gql`
    fragment termBasicDetailsItem on AcademicTerm {
      id
      label
      startDate
      endDate
      abbreviation
      type
      lockingStatus
      dependentEntitiesV2 {
        totalCount
      }
      curriculumProgram {
        id
        type
      }
      learningCourses {
        totalCount
      }
      lockingStatus
      associatedAcademicTermEntities {
        id
        academicTerm {
          id
          abbreviation
          type
        }
        cumulativeAcademicTermWeightages {
          id
          weightage
        }
      }
    }
  `,
};
